import { SoundHandler } from '@helpers/sound';

export function useTestSound() {
  return new SoundHandler();
}
